import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'

import { useCreateBlockingDomainActivityMutation } from '../../redux/apis/blockingDomainsManagement/bDActivitiesApiSlice'
import CustomersDropdown from '../CustomersDropdown'
import CountriesDropdown from '../CountriesDropdown'

const CreateBlockingDomainActivity = ({ open, setOpen }) => {
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateBlockingDomainActivityMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      blocking_in_country: '',
      customer: '',
      media: null,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      blocking_in_country: Yup.string().required('Country is required'),
      customer: Yup.number().required('Customer is required'),
      media: Yup.mixed()
        .required('Excel file is required')
        .test('fileFormat', 'Only Excel files are allowed', value => {
          return (
            value &&
            [
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/vnd.ms-excel'
            ].includes(value.type)
          )
        })
    }),

    onSubmit: async values => {
      const formData = new FormData()
      Object.entries(values).forEach(([key, val]) => {
        if (val !== null && val !== undefined) {
          if (key === 'media') {
            formData.append(key, val)
          } else {
            formData.append(key, String(val))
          }
        }
      })

      try {
        await addService(formData).unwrap()
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd])

  useEffect(() => {
    if (SuccessAdd) {
      toast.success('Blocking Domain Activity created successfully!')
      setOpen(false)
    }
  }, [SuccessAdd])

  return (
    <Modal
      className='customModal'
      open={open}
      title={'Create Blocking Domain Activity'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.values(validation.errors).forEach(errorMsg => {
                toast.error(errorMsg)
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding} />

      {/* Customer */}
      <div className='mb-3'>
        <CustomersDropdown
          onChange={e => validation.setFieldValue('customer', e)}
          value={validation.values.customer}
          onBlur={validation.handleBlur}
        />
        {validation.touched.customer && validation.errors.customer ? (
          <p className='text-danger'>{validation.errors.customer}</p>
        ) : null}
      </div>

      {/* Country */}
      <div className='mb-3'>
        <CountriesDropdown
          onChange={e => validation.setFieldValue('blocking_in_country', e)}
          onBlur={validation.handleBlur}
          value={validation.values.blocking_in_country}
          validation={validation}
        />
        {validation.touched.blocking_in_country &&
        validation.errors.blocking_in_country ? (
          <p className='text-danger'>
            {validation.errors.blocking_in_country}
          </p>
        ) : null}
      </div>

      {/* File Upload */}
      <div className='mb-3'>
        <label>Excel File *</label>
        <div className='flex gap-4 '>
          <Input
            type='file'
            onChange={event =>
              validation.setFieldValue('media', event.currentTarget.files[0])
            }
            accept='.xls,.xlsx'
            onBlur={validation.handleBlur}
            required
            style={{ height: '40px' }}
          />
        </div>
        {validation.touched.media && validation.errors.media ? (
          <p className='text-danger'>{validation.errors.media}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default CreateBlockingDomainActivity
